import React, { useEffect, useState } from 'react';
import Slider from 'react-slick';
import { motion } from 'framer-motion';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Loader } from './Loader';

const BubbleRequest = () => {
  const [releases, setReleases] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Витрина релизов METRIKA из кабинета. Прежний workflow Bubble на
        // paradigm-music.ru после переезда 30.09.2026 отвечает 404.
        const response = await fetch('https://lk.metrikamusic.com/api/smartlinks/label/metrika');

        if (!response.ok) throw new Error('Network response was not ok');

        const data = await response.json();
        const result = data.response;

        const combined = result.coverArt.map((cover, index) => ({
          coverArt: cover,
          smartlink: result.smartlink[index],
          artists: result.artists[index],
          title: result.title[index]
        }));

        setReleases(combined);
        setIsLoaded(true);
      } catch (error) {
        console.error('Error:', error);
      }
    };

    fetchData();
  }, []);

  const PrevArrow = (props) => (
    <div onClick={props.onClick} className='prevArrow'>
      <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M15 18l-6-6 6-6" />
      </svg>
    </div>
  );

  const NextArrow = (props) => (
    <div onClick={props.onClick} className='nextArrow'>
      <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M9 18l6-6-6-6" />
      </svg>
    </div>
  );

  const settings = {
    dots: true,
    infinite: false,
    arrows: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
    initialSlide: 0,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          dots: false
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false
        }
      }
    ]
  };

  // Функция для проверки наличия пути в smartlink
  const hasPathInSmartlink = (smartlink) => {
    try {
      const url = new URL(smartlink);
      return url.pathname !== '/'; // Если путь существует, то он будет не равен "/"
    } catch (error) {
      return false;
    }
  };

  if (!isLoaded) return <Loader />;

  return (
    <div className="container">
      <p className="pageTitles">MUSIC</p>
      <Slider {...settings}>
        {releases.map((release, index) => (
          <motion.div
            key={index}
            className="cover"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: index * 0.1 }}
          >
            {hasPathInSmartlink(release.smartlink) ? (
              <a href={release.smartlink} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: 'inherit' }}>
                <img
                  src={release.coverArt}
                  alt={`Cover ${release.title}`}
                  style={{ width: '200px', height: '200px', marginBottom: '10px' }}
                />
                <p className='release-title'>
                  {release.artists} – {release.title}
                </p>
              </a>
            ) : (
              <div>
                <img
                  src={release.coverArt}
                  alt={`Cover ${release.title}`}
                  style={{ width: '200px', height: '200px', marginBottom: '10px' }}
                />
                <p className='release-title'>
                  {release.artists} – {release.title}
                </p>
              </div>
            )}
          </motion.div>
        ))}
      </Slider>
    </div>
  );
};

export default BubbleRequest;
